"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validatePrimitiveAttribute = void 0;
const index_js_1 = require("../../errors/index.js");
const isStaticDefault_js_1 = require("../../schema/utils/isStaticDefault.js");
const isValidPrimitive_js_1 = require("../../utils/validation/isValidPrimitive.js");
const validate_js_1 = require("../shared/validate.js");
const validatePrimitiveAttribute = (state, path) => {
    (0, validate_js_1.validateAttributeProperties)(state, path);
    const { type, enum: enumValues } = state;
    enumValues === null || enumValues === void 0 ? void 0 : enumValues.forEach(enumValue => {
        if (!(0, isValidPrimitive_js_1.isValidPrimitive)(state, enumValue)) {
            throw new index_js_1.DynamoDBToolboxError('schema.primitiveAttribute.invalidEnumValueType', {
                message: `Invalid enum value type${path !== undefined ? ` at path '${path}'` : ''}. Expected: ${type}. Received: ${String(enumValue)}.`,
                path,
                payload: { expectedType: type, enumValue }
            });
        }
    });
    for (const defaultValue of Object.values(state.defaults)) {
        if (defaultValue !== undefined && (0, isStaticDefault_js_1.isStaticDefault)(defaultValue)) {
            if (!(0, isValidPrimitive_js_1.isValidPrimitive)(state, defaultValue)) {
                throw new index_js_1.DynamoDBToolboxError('schema.primitiveAttribute.invalidDefaultValueType', {
                    message: `Invalid default value type${path !== undefined ? ` at path '${path}'` : ''}: Expected: ${type}. Received: ${String(defaultValue)}.`,
                    path,
                    payload: { expectedType: type, defaultValue }
                });
            }
            if (enumValues !== undefined && !enumValues.some(enumValue => enumValue === defaultValue)) {
                throw new index_js_1.DynamoDBToolboxError('schema.primitiveAttribute.invalidDefaultValueRange', {
                    message: `Invalid default value${path !== undefined ? ` at path '${path}'` : ''}: Expected one of: ${enumValues.join(', ')}. Received: ${String(defaultValue)}.`,
                    path,
                    payload: { enumValues, defaultValue }
                });
            }
        }
    }
};
exports.validatePrimitiveAttribute = validatePrimitiveAttribute;
